/**
 * The browser's time zone, saved on the user — the agents date a turn by it
 * (today where the person is, their weekday, their weekend: "this weekend" is
 * Friday–Saturday in Israel). See backend/shared/services/local_time.py.
 *
 * Written at most once per tab per signed-in user and zone: the memo below is
 * set before the request, so the many components that call useAuth() share
 * one PATCH. A failed write is retried on the next page load.
 */

import api from '@/services/api';
import { browserTimeZone } from '@/utils/browserTimeZone';

const MEMO_KEY = 'timezone_synced';
/** This page's last write, checked before storage (every useAuth() calls in). */
let syncedThisPage: string | null = null;

export function syncTimeZone(userId: string | null | undefined): void {
  if (!userId) return;
  const zone = browserTimeZone();
  if (!zone) return;
  const memo = `${userId}:${zone}`;
  if (syncedThisPage === memo) return;
  syncedThisPage = memo;
  try {
    if (sessionStorage.getItem(MEMO_KEY) === memo) return;
    sessionStorage.setItem(MEMO_KEY, memo);
  } catch {
    return; // no storage: the page memo still keeps it to one PATCH per load
  }
  void api.patch('/auth/me/preferences', { timezone: zone }).catch(() => {
    syncedThisPage = null;
    try {
      sessionStorage.removeItem(MEMO_KEY);
    } catch {
      /* the next page load tries again */
    }
  });
}
